import { render, staticRenderFns } from "./addMemberModal.vue?vue&type=template&id=b84e3ddc&"
import script from "./addMemberModal.vue?vue&type=script&lang=ts&"
export * from "./addMemberModal.vue?vue&type=script&lang=ts&"
import style0 from "./addMemberModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports